(function (root) {
  'use strict';
  function extractSale(doc, product) {
    const source = doc.querySelector('[data-smooche], [data-smooche-simple]');
    const data = source?.querySelector('[data-catalogue]');
    const catalogue = data ? JSON.parse(data.textContent) : [];
    const selected = catalogue.find(item => item.handle === product.handle);
    const identity = source?.dataset.primaryHandle || (product.handle === 'chargeur-chaton' && selected?.variants.some(variant => String(variant.id) === source.dataset.initialVariant) ? product.handle : '');
    if (identity !== product.handle) throw new Error('La vente ne correspond pas au modèle.');
    const hero = source.querySelector('.sm-hero');
    if (!hero || !source.querySelector('#sm-configurator')) throw new Error('Bloc achat incomplet.');
    const page = source.cloneNode(false);
    page.classList.add('lpc-smooche');
    page.dataset.integratedSale = '';
    page.append(hero.cloneNode(true));
    const required = new Set(['sm-configurator', 'sm-fit', 'sm-lightbox']);
    page.querySelectorAll('[data-open]').forEach(button => required.add('sm-' + button.dataset.open));
    required.forEach(id => {
      const dialog = source.querySelector('#' + id);
      if (dialog?.tagName !== 'DIALOG') throw new Error('Dialogue achat incomplet.');
      page.append(dialog.cloneNode(true));
    });
    source.querySelectorAll('script[type="application/json"]').forEach(node => page.append(node.cloneNode(true)));
    page.querySelectorAll('script:not([type="application/json"])').forEach(node => node.remove());
    const original = page.querySelector('.sm-summary h1');
    if (!original) throw new Error('Titre achat absent.');
    const title = doc.createElement('h2');
    Array.from(original.attributes).forEach(attribute => title.setAttribute(attribute.name, attribute.value));
    title.dataset.block = 'title';
    title.textContent = product.title;
    original.replaceWith(title);
    page.querySelectorAll('a[href^="#"]').forEach(link => {
      if (link.hash && !page.querySelector(link.hash)) link.href = product.saleUrl + link.hash;
    });
    return page;
  }
  const loaded = new Map();
  function script(url) {
    if (!loaded.has(url)) loaded.set(url, new Promise((resolve, reject) => {
      const node = document.createElement('script');node.src = url;node.onload = resolve;node.onerror = reject;document.head.append(node);
    }));
    return loaded.get(url);
  }
  async function mount(host) {
    if (host.dataset.state) return;
    host.dataset.state = 'loading';
    const url = new URL(host.dataset.saleUrl, root.location.origin);
    const selectedVariant = new URLSearchParams(root.location.search).get('variant');
    if (selectedVariant) url.searchParams.set('variant', selectedVariant);
    if (url.origin !== root.location.origin || !url.pathname.endsWith('/products/' + host.dataset.handle)) throw new Error('Route achat invalide.');
    const preview = new URLSearchParams(root.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await root.fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Vente indisponible.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const page = extractSale(doc, { handle: host.dataset.handle, title: host.dataset.title, saleUrl: url.pathname + url.search });
    const family = page.dataset.smoocheFamily === 'eleven' ? 'eleven' : page.hasAttribute('data-smooche-simple') ? 'simple' : host.dataset.handle === 'chargeur-chaton' ? 'chaton' : 'catalogue';
    // Match the preview style of the surrounding page inside the shadow boundary.
    host.dataset.bfStyle = document.documentElement.dataset.bfStyle || 'noir';
    const shadow = host.attachShadow({ mode: 'open' });
    const styleUrls = JSON.parse(host.dataset.styles);
    styleUrls.push(host.dataset.deliveryStyle);
    if (family === 'eleven') styleUrls.push(host.dataset.styleEleven);
    const styles = styleUrls.map(href => new Promise((resolve, reject) => {
      const link = document.createElement('link');link.rel = 'stylesheet';link.href = href;link.onload = resolve;link.onerror = reject;shadow.append(link);
    }));
    const style = document.createElement('style');
    style.textContent = ':host{display:block;min-width:0}.lpc-smooche{padding-bottom:60px}.lpc-smooche .sm-summary h2[data-block="title"]{font-size:36px;line-height:1.12;font-weight:600;letter-spacing:-.8px;margin:7px 0}.lpc-smooche .sm-social-adoption a{color:inherit}@media(max-width:749px){.lpc-smooche .sm-summary h2[data-block="title"]{font-size:clamp(23px,7.2vw,29px);line-height:1.12;letter-spacing:-.6px;white-space:normal}}';
    shadow.append(style, document.importNode(page, true));
    await script(host.dataset.deliveryRuntime);
    await Promise.all([...styles, script(host.dataset.routing), script(family === 'eleven' ? host.dataset.videoEleven : host.dataset.video), script(host.dataset['runtime' + family[0].toUpperCase() + family.slice(1)])]);
    root['LPCSmoocheIntegrated' + family[0].toUpperCase() + family.slice(1)].mount(shadow.querySelector('[data-integrated-sale]'));
    host.querySelector('[data-integrated-loading]')?.remove();
    root.LPCDeliveryEstimate.mount(shadow);
    host.dataset.state = 'ready';
    document.dispatchEvent(new CustomEvent('lpc:purchase-mounted'));
  }
  function syncVariant(event) {
    const variant = String(event.detail?.variant || '');
    if (!/^\d+$/.test(variant)) return;
    document.querySelectorAll('[data-smooche-integrated]').forEach(host => {
      const url = new URL(host.dataset.saleUrl, root.location.origin);
      url.searchParams.set('variant', variant);
      host.dataset.saleUrl = url.pathname + url.search;
      const page = host.shadowRoot?.querySelector('[data-integrated-sale]');
      if (page) page.dispatchEvent(new root.CustomEvent('lpc:variant-change', { detail: { variant } }));
    });
  }
  if (typeof document !== 'undefined') document.addEventListener('lpc:variant-change', syncVariant);
  function start() {
    document.querySelectorAll('[data-smooche-integrated]').forEach(host => {
      const run = () => mount(host).catch(() => {
        if (host.shadowRoot) host.shadowRoot.replaceChildren(document.createElement('slot'));
        host.dataset.state = 'error';
        const message = host.querySelector('[data-integrated-loading]');
        if (message) message.firstChild.textContent = 'Retrouvez les options sur la page d’achat. ';
      });
      if ('IntersectionObserver' in root) {
        const observer = new root.IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect();run(); } }, { rootMargin: '900px' });
        observer.observe(host);
      } else run();
    });
  }
  const api = { extractSale, mount };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else { root.LPCSmoocheIntegrated = api;if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });else start(); }
})(typeof window !== 'undefined' ? window : globalThis);
